import LayoutPage from "../layouts/base3";
import { faPlus, faPencil, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Form, Modal } from 'react-bootstrap';
import SuccessModal from "../components/success-modal";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL, IMAGE_BASE_URL } from "../constants/apiConfig";
import { useAuth } from "../services/AuthProvider";


function RoleListPage() {

    const { user, hasPermission } = useAuth();

    const canManageRole = hasPermission('manage-role');
    const canCreateRole = hasPermission('create-role');
    const canEditRole = hasPermission('edit-role');
    const canDeleteRole = hasPermission('delete-role');

    const [roleData, setRoleData] = useState([]);
    const [permissionData, setPermissionData] = useState([]);
    const handleRoleModal = () => setShowModal(true);
    const handleModalClose = () => setShowModal(false);
    const [showModal, setShowModal] = useState(false);
    const [roleName, setRoleName] = useState('');
    const [checkedPermissions, setCheckedPermissions] = useState([]);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showSuccessDeleteModal, setshowSuccessDeleteModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);
    const [editRoleName, setEditRoleName] = useState('');
    const [editRoleId, setEditRoleId] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const handleEditModalClose = () => setShowEditModal(false);
    const [editRoleData, setEditRoleData] = useState([]);

    useEffect(() => {
        const fetchRoleData = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}role/index`);
                if (response.ok) {
                    const data = await response.json();
                    setRoleData(data.roles);
                    setPermissionData(data.permissions);
                }
            } catch (error) {
                console.error('Error fetching zone data:', error);
            }
        };

        fetchRoleData();
    }, []);

    const handleNameChange = (e) => {
        setRoleName(e.target.value);
    };

    const handlePermissionChange = (permissionId, checked) => {
        if(checked) {
            setCheckedPermissions([...checkedPermissions, permissionId]);
        } else {
            setCheckedPermissions(checkedPermissions.filter(permission => permission !== permissionId));
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${API_BASE_URL}role/store`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    roleName: roleName,
                    rolePermissions: checkedPermissions,
                }),
            });

            if (response.status == 200) {
                setShowModal(false);
                setShowSuccessModal(true);
            }

        } catch (error) {
            // Handle fetch errors
            console.error('Error:', error);
        }
    }

    const closeSuccessModal = () => {
        setShowSuccessModal(false);
        window.location.reload();
    };

    const handleDeleteRole = async (index) => {
        try {
            const response = await fetch(`${API_BASE_URL}role/destroy/${index}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.status == 200) {
                setShowDeleteModal(false);
                setshowSuccessDeleteModal(true);
            }

        } catch (error) {
            // Handle fetch errors
            console.error('Error:', error);
        }
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setDeleteIndex(null);
    };

    const handleConfirmDelete = (id) => {
        setDeleteIndex(id);
        setShowDeleteModal(true);
    };

    const handleEditRoleModal = (roleId) => {
        setEditRoleId(roleId);
        setShowEditModal(true);
    };

    // Function to fetch role data by ID
    const fetchRoleById = async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}role/edit/${id}`);
            if (response.ok) {
                const data = await response.json();

                const role = data.role;
                setEditRoleData(role);
                setEditRoleName(role.name)
            }
        } catch (error) {
            console.error('Error fetching zone:', error);
        }
    };

    useEffect(() => {
        if (editRoleId !== null) {
            fetchRoleById(editRoleId);
        }
    }, [editRoleId]);

    const handleEditNameChange = (event) => {
        setEditRoleName(event.target.value);
    };

    const handleUpdatePermissionChange = (permissionId, checked) => {
        console.log('Before:', editRoleData.permissions);

        setEditRoleData(prevData => {
            const updatedPermissions = checked
                ? [...prevData.permissions, { id: permissionId }]
                : prevData.permissions.filter(permission => permission.id !== permissionId);

            console.log('After:', updatedPermissions);

            return { ...prevData, permissions: updatedPermissions };
        });
    }

    const handleUpdateRole = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch(`${API_BASE_URL}role/update/${editRoleId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    roleName: editRoleName,
                    rolePermissions: editRoleData.permissions.map(permission => permission.id),
                }),
            });

            if (response.ok) {
                setShowEditModal(false);
                setShowSuccessModal(true);
            }
        } catch (error) {
            // Handle fetch errors
            console.error('Error updating zone:', error);
        }
    }

    return (
        <LayoutPage>
            <div className='children'>
                <div className="d-flex listTopBar top_bar p-3 bold_poppins justify-content-between">
                    <h4 className=" pg_title">
                        SENARAI PERANAN
                    </h4>
                </div>
                {canCreateRole && <div className="addZone mt-3 mx-3 d-flex justify-content-center mb-4" onClick={handleRoleModal}>
                    <div className="icon">
                        <FontAwesomeIcon className="icon" icon={faPlus} />
                    </div>
                    <div className="text">
                        Peranan
                    </div>
                </div>}
                <div>
                    <div className='m-3 table-container table_responsive'>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Nama</th>
                                    {(canEditRole || canDeleteRole) && <th className='text-center'>Tindakan</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {roleData.length > 0 ? (
                                    roleData.map((role, index) => (
                                        <tr key={role.id}>
                                            <td>{ index + 1 }</td>
                                            <td>{ role.name }</td>
                                            {(canEditRole || canDeleteRole) && <td className='text-center'>
                                                <div className="unwrap editdelete_icon">
                                                    {canEditRole && <FontAwesomeIcon icon={faPencil} className="icon edit-icon" onClick={() => handleEditRoleModal(role.id)} /> }
                                                    {canDeleteRole && <FontAwesomeIcon icon={faTrash} className="icon delete-icon" onClick={() => handleConfirmDelete(role.id)}/>}
                                                </div>
                                            </td>}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center">Tiada data ditemui</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>

            {/* Modal Create Role */}
            <Modal className='modal_disease' show={showModal} onHide={handleModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Tambah Peranan Baru</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="" >
                            <Form.Label className="label-left">Nama</Form.Label>
                            <Form.Control value={roleName} onChange={handleNameChange} type="text" placeholder="Masukkan nama peranan" required />
                        </Form.Group>
                        <Form.Group controlId="" className=''>
                            <Form.Label className="label-left mt-3">Kebenaran Peranan</Form.Label>
                            <div className='row ml-0'>
                                {permissionData.map((permission, index) => {

                                    const formattedLabel = permission.name.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

                                    return (
                                        <Form.Check
                                            key={index}
                                            className={`col-md-6 col-6 mb-2 label-left`}
                                            label={formattedLabel}
                                            name={`group${index + 1}`}
                                            onChange={(e) => handlePermissionChange(permission.id, e.target.checked)}
                                        />
                                    );
                                })}
                            </div>
                        </Form.Group>

                        <Button variant="primary" type="submit" className="mt-4">
                            Simpan
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Modal Edit Role */}
            <Modal className='modal_disease' show={showEditModal} onHide={handleEditModalClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Kemaskini Peranan</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleUpdateRole}>
                        <Form.Group controlId="" >
                            <Form.Label className="label-left">Nama</Form.Label>
                            <Form.Control value={editRoleName} onChange={handleEditNameChange} type="text" placeholder="Masukkan nama peranan" required />
                        </Form.Group>
                        <Form.Group controlId="" className=''>
                            <Form.Label className="label-left mt-3">Kebenaran Peranan</Form.Label>
                            <div className='row ml-0'>
                                {permissionData.map((permission, index) => {

                                    const formattedLabel = permission.name.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

                                    return (
                                        <Form.Check
                                            key={index}
                                            className={`col-md-6 col-6 mb-2 label-left`}
                                            label={formattedLabel}
                                            name={`group${index + 1}`}
                                            checked={editRoleData.permissions && editRoleData.permissions.some(rolePermission => rolePermission.id === permission.id)}
                                            onChange={(e) => handleUpdatePermissionChange(permission.id, e.target.checked)}
                                        />
                                    );
                                })}
                            </div>
                        </Form.Group>

                        <Button variant="primary" type="submit" className="mt-4">
                            Kemaskini
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Modal/Popup for Success Message */}
            <SuccessModal
                show={showSuccessModal}
                onHide={closeSuccessModal}
                title="Tindakan Berjaya"
                modalBody={<p>Data telah berjaya disimpan!</p>}
                buttonText="Tutup"
            />

            {/* Delete Modal */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Pengesahan Padam</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                Adakah anda pasti ingin memadam peranan ini?
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseDeleteModal}>
                        Batal
                    </Button>
                    <Button className="delete-button" onClick={() => handleDeleteRole(deleteIndex)}>
                        Padam
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal/Popup for Confirmation Delete */}
            <SuccessModal
                show={showSuccessDeleteModal}
                onHide={closeSuccessModal}
                title="Tindakan Berjaya"
                modalBody={<p>Data telah berjaya dipadam!</p>}
                buttonText="Tutup"
            />

        </LayoutPage>
    )
}

export default RoleListPage